import { useDeviceType } from './hooks/useDeviceType';
import { MobileApp } from './mobile/MobileApp';
import { B2BMobileApp } from './b2b_mobile/MobileApp';
import { TabletApp } from './tablet/TabletApp';

export function App() {
  const isMobile = useDeviceType();

  // Check URL params or path for B2B mode
  const urlParams = new URLSearchParams(window.location.search);
  const isB2B = urlParams.get('app') === 'b2b' || 
                urlParams.get('mode') === 'b2b' || 
                window.location.pathname.startsWith('/b2b') ||
                localStorage.getItem('appMode') === 'b2b';

  if (!isMobile) {
    return <TabletApp />;
  }

  return isB2B ? <B2BMobileApp /> : <MobileApp />;
}
